import { render, staticRenderFns } from "./UsuarioList.vue?vue&type=template&id=4eb8b735"
import script from "./UsuarioList.vue?vue&type=script&lang=ts"
export * from "./UsuarioList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports